module.exports = __webpack_public_path__ + "static/PHP_Wordpress-Still-99447d7c33ecc5385a12c9a7a5093227.jpg";